import { render } from "./BreadCrumbs.vue?vue&type=template&id=fff5b478&scoped=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=fff5b478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff5b478"]])

export default __exports__